const tabsContainers = document.querySelectorAll('.tab-container')

const setActiveTab = (tabs, activeTab, contents) => {
	if (activeTab.classList.contains('active')) return

	const index = [...tabs].indexOf(activeTab)

	tabs.forEach((tab, idx) => tab.classList.toggle('active', idx === index))
	contents.forEach((content, idx) => content.classList.toggle('hidden', idx !== index))
}

tabsContainers.forEach(container => {
	const tabs = container.querySelectorAll('.tab')
	const tabsContent = container.querySelectorAll('.tab-content')
	tabs.forEach(tab => tab.addEventListener('click', () => setActiveTab(tabs, tab, tabsContent)))
	setActiveTab(tabs, tabs[0], tabsContent)
})